"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "<pre style=\"tab-size: 2; border-bottom-width: 4px; line-height: 1.4\">\n<code>\n{{> clause}}\n</code>\n</pre>";
//# sourceMappingURL=main.js.map